import React, { useState, useEffect } from 'react'
import { Panel, IconButton, Icon, Whisper, Tooltip, Message, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import OrganicVegetablesBGForm from './OrganicVegetablesBGForm'
import OrganicVegetablesBGView from './OrganicVegetablesBGView'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import { updateForm3, saveForm3 } from '../../../../redux/actions/background'
import ButtonPanel from '../../../ButtonPanel'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'
import WhisperMoreContent from '../../../WhisperMoreContent'

export default function OrganicVegetablesBGWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [moreContent, setMoreContent] = useState(true)
  const [moreContentBottom, setMoreContentBottom] = useState(true)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateForm3(projectId, request)
      } else {
        console.log('call save.')
        response = await saveForm3(projectId, request)
      }

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      community: data.community || '',
      totalPopulation: data.totalPopulation || 0,
      totalHouseholds: data.totalHouseholds || 0,
      notGrowVegetable: data.notGrowVegetable || 0,
      useChemicals: data.useChemicals || 0,
      useChemicalsBudget: data.useChemicalsBudget || 0,
      notUseChemicals: data.notUseChemicals || 0,
      growVegetableType: data.growVegetableType,
      notBuy: data.notBuy || 0,
      buyNotSafe: data.buyNotSafe || 0,
      buyNotSafeBudget: data.buyNotSafeBudget || 0,
      behaviorOther: data.behaviorOther,
      editorData1: data.editorData1 || '',
      editorData2: data.editorData2 || '',
      editorData3: data.editorData3 || '',
    }

    console.log('request', request)
    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {formSchema.introduction && (
        <>
          {moreContent && (
            <>
              <div dangerouslySetInnerHTML={{ __html: formSchema.introduction }} />
            </>
          )}
          <div style={{ textAlign: 'center', marginTop: 10 }}>
            <WhisperMoreContent
              isShow={moreContent}
              onClick={() => {
                setMoreContent(!moreContent)
              }}
            />
          </div>
        </>
      )}

      {isEdit && showCommandButton ? (
        <OrganicVegetablesBGForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      ) : (
        <OrganicVegetablesBGView schema={formSchema} />
      )}

      {formSchema.footer && (
        <>
          <div style={{ textAlign: 'center' }}>
            <WhisperMoreContent
              isShow={moreContentBottom}
              onClick={() => {
                setMoreContentBottom(!moreContentBottom)
              }}
            />
          </div>
          {moreContentBottom && <div dangerouslySetInnerHTML={{ __html: formSchema.footer }} />}
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}

// const formSchemas = {
//   header: 'ความเป็นมา/ หลักการและเหตุผล/ ความสำคัญของปัญหา (03 ผักปลอดสารเคมีในครัวเรือน ปี 63)',
//   introduction:
//     '<p> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; องค์การอนามัยโลกและองค์การอาหารและเกษตรแห่งสหประชาชาติได้รวบรวมข้อมูลงานวิจัยต่างๆ โดยผลสรุปว่าการบริโภคผักผลไม้วันละ 400-600 กรัม สามารถลดภาระโรคต่างๆ ได้แก่ หัวใจขาดเลือด  เส้นเลือดในสมองตีบ ลดอัตราการป่วยและเสียชีวิตจากมะเร็งกระเพาะอาหาร มะเร็งปอด มะเร็งลำไส้ใหญ จึงกำหนดการบริโภคผัก ผลไม้อย่างน้อย 400 กรัมต่อคนต่อวันเพื่อลดความเสี่ยงต่อโรคต่างๆ  </p> <p>  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ในปัจจุบัน การซื้อผักผลไม้ตามท้องตลาดมาบริโภคนั้นมีความเสี่ยงในเรื่องสารพิษตกค้าง ซึ่งหากบริโภคเป็นประจำอาจเกิดการสะสม และส่งผลกระทบต่อสุขภาพในระยะยาว ทั้งในเรื่องของประสาทสัมผัส การเคลื่อนไหวบกพร่อง เกิดความผิดปกติทางกายภาพของต่อมไทรอยด์ นอกจากนี้ยังมีรายงานว่าสารป้องกันกำจัดแมลงบางชนิดมีความสัมพันธ์กับการเกิดมะเร็ง เช่น มะเร็งต่อมลูกหมาก มะเร็งตับอ่อน มะเร็งเต้านม และมะเร็งผิวหนัง </p>  <p> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ในปัจจุบัน จากการสุ่มตรวจสารเคมีกำจัดศัตรูพืชตกค้างในผลผลิตทางการเกษตรของเครือข่ายเตือนภัยสารเคมีกำจัดศัตรูพืช (Thai-PAN) ครั้งที่ 2 ปี 2559 พบว่าแหล่งจำหน่ายที่พบสารพิษตกค้างในตัวอย่างเกินค่า MRL มากที่สุด คือ ห้างโมเดิร์นเทรด สารพิษตกค้างเกินมาตรฐานมากถึง 70.2% (33 ตัวอย่างจาก 47 ตัวอย่าง) ในขณะที่พบสารพิษตกค้างในผักและผลไม้จากตลาดค้าส่ง 54.2% (26 ตัวอย่างจาก 48 ตัวอย่าง) ส่วนผักที่ได้รับตรารับรองจากกระทรวงเกษตรและสหกรณ์พบสารพิษตกค้าง เกินมาตรฐานมากกว่าผักและผลไม้ทั่วไป โดยฉลากสินค้า Q-GAP พบสารพิษตกค้างเกินค่า MRL 10 จาก 16 ตัวอย่าง รองลงมาคือ Q-GMP พบ 6 จาก 10 ตัวอย่าง และผักผลไม้ที่ติดฉลากว่าเป็นสินค้าปลอดภัย แต่ไม่แสดงตรารับรองมาตรฐานพบ 5 จาก 10 ตัวอย่าง นอกจากนี้ ตัวอย่างที่แสดงตรารับรอง Organic Thailand พบสารพิษตกค้างเกินค่า MRL 2 จาก 10 ตัวอย่าง ส่วนตรารับรองอินทรีย์อื่นพบใกล้เคียงกัน คือพบ 2 จาก 9 ตัวอย่าง ส่วนตัวอย่างสินค้าที่ระบุว่า เป็นผักและผลไม้อินทรีย์ที่ขายในห้างต่างๆ ซึ่งไม่แสดงตรารับรองมาตรฐานนั้น พบสารพิษตกค้างเกินค่า MRL จำนวน 4 ตัวอย่างจากจำนวนที่สุ่มตรวจ 8 ตัวอย่าง ทำให้เห็นว่าแม้สินค้าที่ซื้อราคาสูงจากห้างโมเดิร์นเทรด หรือสินค้าที่ติดฉลากว่าปลอดภัย หรือเป็นสินค้าอินทรีย์ก็ยังพบว่าไม่ปลอดภัย ดังนั้นแนวทางการปลูกผักและผลไม้ปลอดสารเคมีเพื่อการบริโภคน่าจะเป็นทางเลือกที่แก้ไขปัญหาการบริโภคผักผลไม้ที่มีสารพิษตกค้างได้ดีที่สุด(www.thaipan.org)</p>',
//   communityBackground: {
//     label: 'ข้อมูลพื้นฐานชุมชน',
//     community: {
//       name: 'community',
//       label: 'ชุมชน : ',
//       value: 'XXXXXXXXXX',
//       validators: [
//         {
//           type: 'REQUIRED',
//           errorMessage: 'กรุณากรอกข้อมูล',
//         },
//       ],
//     },
//     totalPopulation: {
//       name: 'totalPopulation',
//       label: 'ประชากรทั้งสิ้น : ',
//       value: '10000',
//       preLabel: 'จำนวน',
//       postLabel: 'คน',
//       validators: [
//         {
//           type: 'REQUIRED',
//           errorMessage: 'กรุณากรอกข้อมูล',
//         },
//       ],
//     },
//     totalHouseholds: {
//       name: 'totalHouseholds',
//       label: 'จำนวนครัวเรือน : ',
//       value: '200',
//       preLabel: 'จำนวน',
//       postLabel: 'ครัวเรือน',
//       validators: [
//         {
//           type: 'REQUIRED',
//           errorMessage: 'กรุณากรอกข้อมูล',
//         },
//       ],
//     },
//     vegetableGrowInfo: 'ข้อมูลการปลูกผักของคนในชุมชน',
//     notGrowVegetable: {
//       name: 'notGrowVegetable',
//       label: 'ครัวเรือนที่ไม่ปลูกผัก',
//       preLabel: 'จำนวน',
//       postLabel: 'ครัวเรือน',
//       value: '',
//       validators: [],
//     },
//     useChemicals: {
//       name: 'useChemicals',
//       label: 'ครัวเรือนที่ปลูกผักใช้สารเคมี',
//       preLabel: 'จำนวน',
//       postLabel: 'ครัวเรือน',
//       value: '',
//       validators: [],
//     },
//     useChemicalsBudget: {
//       name: 'useChemicalsBudget',
//       label: 'โดยมีค่าใช้จ่ายในการซื้อสารเคมี',
//       preLabel: 'จำนวน',
//       postLabel: 'บาท/ครัวเรือน',
//       value: '',
//       validators: [],
//     },
//     notUseChemicals: {
//       name: 'notUseChemicals',
//       label: 'ครัวเรือนที่ปลูกผักโดยไม่ใช้สารเคมี',
//       preLabel: 'จำนวน',
//       postLabel: 'ครัวเรือน',
//       value: '',
//       validators: [],
//     },
//     growVegetableType: {
//       name: 'growVegetableType',
//       label: 'โดยผักที่ปลูกได้แก่',
//       value: '',
//       validators: [],
//     },
//     vegetableConsumption: '1) พฤติกรรมการบริโภคผักของคนในชุมชน',
//     notBuy: {
//       name: 'notBuy',
//       label: 'บริโภคผักที่ปลูกเอง',
//       preLabel: 'จำนวน',
//       postLabel: 'ครัวเรือน',
//       value: '',
//       validators: [],
//     },
//     buyNotSafe: {
//       name: 'buyNotSafe',
//       label: 'ซื้อผักไม่ปลอดภัยจากตลาดมาบริโภค',
//       preLabel: 'จำนวน',
//       postLabel: 'ครัวเรือน',
//       value: '',
//       validators: [],
//     },
//     buyNotSafeBudget: {
//       name: 'buyNotSafeBudget',
//       label: 'โดยมีค่าใช้จ่ายในการซื้อผัก',
//       preLabel: 'จำนวน',
//       postLabel: 'บาท/ครัวเรือน',
//       value: '',
//       validators: [],
//     },
//     behaviorOther: {
//       name: 'behaviorOther',
//       label: 'อื่นๆ(โปรดระบุ)',
//       value: '',
//       validators: [],
//     },
//     editorData1: {
//       name: 'editorData1',
//       label:
//         'โปรดอธิบายพฤติกรรมการบริโภคผัก การปลูกผัก การซื้อผัก และการใช้สารเคมีปลูกผักในชุมชน รวมถึงทุนเดิมของชุมชนที่มี เช่น กลไก/การรวมกลุ่มปลูกผักในชุมชน องค์ความรู้เรื่องผัก/ชนิดพันธุ์ผักพื้นบ้าน (ถ้ามี)',
//       value: 'XXXXXXXXXX',
//       validators: [
//         {
//           type: 'REQUIRED',
//           errorMessage: 'กรุณากรอกข้อมูล',
//         },
//       ],
//     },
//     editorData2: {
//       name: 'editorData2',
//       label:
//         'มีปัญหาและได้รับผลกระทบจากการใช้สารเคมีในการปลูกผัก/การบริโภคผักที่มีสารเคมีตกค้างในชุมชนเป็นอย่างไร โปรดอธิบายพร้อมทั้งระบุรายละเอียด (เช่น ข้อมูลการสำรวจการตกค้างของสารพิษในผักและผลไม้ในชุมชน)',
//       value: 'XXXXXXXXXX',
//       validators: [
//         {
//           type: 'REQUIRED',
//           errorMessage: 'กรุณากรอกข้อมูล',
//         },
//       ],
//     },
//     editorData3: {
//       name: 'editorData3',
//       label: 'สาเหตุของปัญหาดังกล่าวนั้นเกิดจากอะไร โปรดอธิบายพร้อมทั้งระบุรายละเอียด',
//       value: 'XXXXXXXXXX',
//       validators: [
//         {
//           type: 'REQUIRED',
//           errorMessage: 'กรุณากรอกข้อมูล',
//         },
//       ],
//     },
//   },
// }
